import UserApiUtils from '../utils/api/user';

export const CLEAR_STUDENT_DATA = 'CLEAR_STUDENT_DATA';
export const FETCH_STUDENT_SENT = 'FETCH_STUDENT_SENT';
export const FETCH_STUDENT_SUCCEEDED = 'FETCH_STUDENT_SUCCEEDED';
export const FETCH_STUDENT_FAILED = 'FETCH_STUDENT_FAILED';

export function clearStudentData() {
  return {
    type: CLEAR_STUDENT_DATA,
  };
}

export function fetchOneSent() {
  return {
    type: FETCH_STUDENT_SENT,
  };
}

export function fetchOneSucceeded(data) {
  return {
    type: FETCH_STUDENT_SUCCEEDED,
    payload: data,
  };
}

export function fetchOneFailed(error) {
  return {
    type: FETCH_STUDENT_FAILED,
  };
}

export function fetchOne(id) {
  return (dispatch) => {
    dispatch(fetchOneSent());
    return UserApiUtils.fetchOne(id).then(
      (data) => dispatch(fetchOneSucceeded(data)),
      (error) => dispatch(fetchOneFailed(error)),
    );
  };
}
